import {
  GET_REMEDIATION_DATA_REQUEST,
  GET_REMEDIATION_DATA_SUCCESS,
  GET_REMEDIATION_DATA_FAIL,
  GET_REMEDIATION_DATA_RESET,
  GET_REMEDIATION_REPORT_RESET,

  // Test List
  GET_TEST_LIST_REQUEST,
  GET_TEST_LIST_SUCCESS,
  GET_TEST_LIST_FAIL,
  GET_TEST_LIST_RESET,

  // Publish
  PUBLISH_REMEDIATION_DATA_FAIL,
  PUBLISH_REMEDIATION_DATA_REQUEST,
  PUBLISH_REMEDIATION_DATA_SUCCESS,

  // Refresh
  REFRESH_REMEDIATION_DATA_FAIL,
  REFRESH_REMEDIATION_DATA_REQUEST,
  REFRESH_REMEDIATION_DATA_SUCCESS,

  // Save
  SAVE_REMEDIATION_DATA_FAIL,
  SAVE_REMEDIATION_DATA_REQUEST,
  SAVE_REMEDIATION_DATA_SUCCESS,

  // Update
  UPDATE_HEADER_INFO_REQUEST,
  UPDATE_HEADER_INFO_SUCCESS,
  UPDATE_HEADER_INFO_FAIL,

  // Selection
  ROW_SELECTION_REQUEST,
  ROW_SELECTION_SUCCESS,
  ROW_SELECTION_FAIL,
  ADD_REMEDIATION_ROW_REQUEST,
  ADD_REMEDIATION_ROW_SUCCESS,
  ADD_REMEDIATION_ROW_FAIL,
} from "../../types/remediation_priorities_document/remediationPrioritiesDocumentTypes";

const remediationPrioritiesDocumentInitialState = {
  reportData: {},
  selectedRows: [],
  hiddenRows: [],
  testListLoading: false,
  rowSelectionLoading: false,
  getRemediationLoading: false,
  updateHeaderInfoLoading: false,
  updateTableLinesLoading: false,
  saveRemediationDataLoading: false,
  publishRemediationDataLoading: false,
  refreshRemediationDataLoading: false,
  testList: [],
  error: "",
};

export const remediationPrioritiesDocumentReducers = (
  state = remediationPrioritiesDocumentInitialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    // Test List
    case GET_TEST_LIST_REQUEST:
      return {
        ...state,
        testListLoading: true,
      };
    case GET_TEST_LIST_SUCCESS:
      return {
        ...state,
        testListLoading: false,
        testList: payload,
        error: "",
      };
    case GET_TEST_LIST_RESET:
      return {
        ...state,
        testListLoading: false,
        testList: [],
        error: "",
      };
    case GET_TEST_LIST_FAIL:
      return {
        ...state,
        testListLoading: false,
        error: payload,
        testList: [],
      };

    // Get Report
    case GET_REMEDIATION_DATA_REQUEST:
      return {
        ...state,
        getRemediationLoading: true,
      };
    case GET_REMEDIATION_DATA_SUCCESS: {
      return {
        ...state,
        getRemediationLoading: false,
        reportData: payload,
        error: "",
      };
    }
    case GET_REMEDIATION_DATA_RESET:
      return {
        ...state,
        getRemediationLoading: false,
        selectedRows: [],
        reportData: {},
        error: "",
      };
    case GET_REMEDIATION_DATA_FAIL:
      return {
        ...state,
        getRemediationLoading: false,
        selectedRows: [],
        reportData: {},
        error: payload,
        rowSelectionLoading: false,
        clientFlagSelectionLoading: false,
        updateHeaderInfoLoading: false,
        updateTableLinesLoading: false,
        updateSummaryInfoLoading: false,
        saveRemediationDataLoading: false,
        publishRemediationDataLoading: false,
        refreshRemediationDataLoading: false,
      };

    // Add Row
    case ADD_REMEDIATION_ROW_REQUEST:
      return {
        ...state,
        rowSelectionLoading: true,
      };
    case ADD_REMEDIATION_ROW_SUCCESS: {
      return {
        ...state,
        rowSelectionLoading: false,
        reportData: payload,
        error: "",
      };
    }
    case ADD_REMEDIATION_ROW_FAIL:
      return {
        ...state,
        rowSelectionLoading: false,
      };

    //Update Header Report
    case UPDATE_HEADER_INFO_REQUEST:
      return {
        ...state,
        updateHeaderInfoLoading: true,
      };
    case UPDATE_HEADER_INFO_SUCCESS:
      return {
        ...state,
        updateHeaderInfoLoading: false,
        reportData: payload,
        error: "",
      };
    case UPDATE_HEADER_INFO_FAIL:
      return {
        ...state,
        updateHeaderInfoLoading: false,
        error: payload,
      };

    // Save Report
    case SAVE_REMEDIATION_DATA_REQUEST:
      return {
        ...state,
        saveRemediationDataLoading: true,
      };
    case SAVE_REMEDIATION_DATA_SUCCESS:
      return {
        ...state,
        saveRemediationDataLoading: false,
      };
    case SAVE_REMEDIATION_DATA_FAIL:
      return {
        ...state,
        saveRemediationDataLoading: false,
        error: payload,
      };

    // Row Selection
    case ROW_SELECTION_REQUEST:
      return {
        ...state,
        rowSelectionLoading: true,
      };
    case ROW_SELECTION_SUCCESS:
      return {
        ...state,
        rowSelectionLoading: false,
        reportData: payload,
        error: "",
      };
    case ROW_SELECTION_FAIL:
      return {
        ...state,
        rowSelectionLoading: false,
        error: payload,
      };

    // Publish Report
    case PUBLISH_REMEDIATION_DATA_REQUEST:
      return {
        ...state,
        publishRemediationDataLoading: true,
      };
    case PUBLISH_REMEDIATION_DATA_SUCCESS:
      return {
        ...state,
        publishRemediationDataLoading: false,
      };
    case PUBLISH_REMEDIATION_DATA_FAIL:
      return {
        ...state,
        publishRemediationDataLoading: false,
        error: payload,
      };

    // Refresh Report
    case REFRESH_REMEDIATION_DATA_REQUEST:
      return {
        ...state,
        refreshRemediationDataLoading: true,
      };
    case REFRESH_REMEDIATION_DATA_SUCCESS:
      return {
        ...state,
        refreshRemediationDataLoading: false,
      };
    case REFRESH_REMEDIATION_DATA_FAIL:
      return {
        ...state,
        refreshRemediationDataLoading: false,
        error: payload,
      };

    case GET_REMEDIATION_REPORT_RESET:
      return {
        ...state,
        testListLoading: false,
        error: "",
        testList: [],
        inspectorList: [],
        getRemediationLoading: false,
        selectedRows: [],
        rowSelectionLoading: false,
        clientFlagSelectionLoading: false,
        updateHeaderInfoLoading: false,
        updateSummaryInfoLoading: false,
        updateTableLinesLoading: false,
        saveRemediationDataLoading: false,
        publishRemediationDataLoading: false,
        refreshRemediationDataLoading: false,
        reportData: {},
      };
    default:
      return state;
  }
};
